import angular from 'angular'

import { isAllDefined } from '../utils/bits'

import setCss from '../utils/set-css'
import extractRawElm from '../utils/extract-raw-elm'

angular
  .module('ggs.visible')
  .directive('ggsVisible', VisibleDirective)

function VisibleDirective($parse) {
  return {
    restrict: 'A',
    link: realLink
  }

  function realLink($scope, $elm, $attr) {
    const elm = extractRawElm($elm)
    const ngExp = $parse($attr.ggsVisible)
    const init = ngExp($scope)

    if (isAllDefined(init) && ngExp.oneTime) {
      applyVisibility(init)
    } else {
      $scope.$watch(ngExp, applyVisibility)
    }

    function applyVisibility(visible) {
      if (visible) {
        setCss(elm, 'visibility', null)
      } else {
        setCss(elm, 'visibility', 'hidden')
      }
    }
  }
}
